"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const t=require("@mui/material"),e=require("@mui/material/styles"),i=e.styled(t.RadioGroup)`
  margin-left: 11px;
`,r=e.styled("div")`
  width: 50%;
`,d=e.styled("div")`
  display: flex;
  gap: 8px;
  width: 100%;
  margin-bottom: 8px;
`;exports.FieldWrapper=r;exports.FieldsGroup=d;exports.StyledRadioGroup=i;
